import { createSelector } from 'reselect'
import configurationDataSelector from './configurationDataSelector'

const configurationStringSelector = createSelector(
    configurationDataSelector,
    (configurationData): string => configurationData.configurationString,
)

export default configurationStringSelector
